import axios from "axios";
import { getLocalStorage } from "global/utils/safeJsonParse";
let flgBackend = null;
let baseUrl;
let opcErrorPonerMantenimiento;

const axiosLogin = async () => {
  if (flgBackend === null) {
    baseUrl = await fetch(`/config.json?v=${new Date().getTime()}`);
    baseUrl = await baseUrl.json();
    opcErrorPonerMantenimiento = await baseUrl.opcErrorPonerMantenimiento;
    baseUrl = await baseUrl.wsLogin;
    flgBackend = true;
  }

  let headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
    Accept: "application/json",
  };

  if (sessionStorage.token) {
    headers.Authorization = `Bearer ${sessionStorage.token}`;
  }

  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers,
    timeout: 20000,
  });

  axiosInstance.interceptors.response.use(
    (response) =>
      new Promise((resolve, _reject) => {
        resolve(response);
      }),
    (error) => {
      if (!error.response) {
        if (opcErrorPonerMantenimiento) {
          sessionStorage.removeItem("token");
          let config = getLocalStorage("config", {});
          const dtoMantenimiento = {
            mantenimiento: true,
            mantenimientoMsj:
              "El portal se encuentra momentaneamente en mantenimiento. Por favor, intente nuevamente en unos minutos",
          };
          config = { ...config, ...dtoMantenimiento };
          localStorage.setItem("config", JSON.stringify(config));
        }
        return new Promise((_resolve, reject) => {
          reject(error);
        });
      }
      if (error.response.status === 401) {
        const url = (error.config?.url || "").toLowerCase();
        if (url.includes("/auth") || url.includes("/login")) {
          return Promise.reject(error);
        }
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("refreshToken");
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("token");
        window.location.href = "/";
        return new Promise(() => {});
      }
      if (error.response.status === 503) {
        if (opcErrorPonerMantenimiento) {
          sessionStorage.removeItem("token");
          let config = getLocalStorage("config", {});
          const dtoMantenimiento = {
            mantenimiento: true,
            mantenimientoMsj:
              "El portal se encuentra momentaneamente en mantenimiento. Por favor, intente nuevamente en unos minutos",
          };
          config = { ...config, ...dtoMantenimiento };
          localStorage.setItem("config", JSON.stringify(config));
        }
      } else {
        return new Promise((_resolve, reject) => {
          reject(error);
        });
      }
    }
  );
  return axiosInstance;
};

export default axiosLogin;
